import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  margin-top: ${spacing.majorScale(1)}px;

  > :not(:first-child) {
    margin-top: ${spacing.majorScale(3)}px;
  }
`
